import { render, staticRenderFns } from "./DashboardTitle.vue?vue&type=template&id=8b587e1a&scoped=true&"
import script from "./DashboardTitle.vue?vue&type=script&lang=js&"
export * from "./DashboardTitle.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTitle.vue?vue&type=style&index=0&id=8b587e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b587e1a",
  null
  
)

export default component.exports